import { getApiContext, GetInitialPropsType } from "~/api"
import { generateCrumbs } from "~/helpers/generateCrumbs"
import InvestorsAndShareholders from "~/views/investors-and-shareholders"

const getInitialProps: GetInitialPropsType = async ({ req }) => {
  const apiContext = await getApiContext(
    [
      { url: "/year/reports" },
      { url: "/investors/page" },
      { url: "/ratings/list" },
      { url: "/calendar/list" },
      { url: "/formwithcontacts/list", code: "investors-and-shareholders" },
    ],
    req ? req.headers.host : location.host,
  )

  const crumbs = generateCrumbs(req?.url)

  return { apiContext, crumbs }
}

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
InvestorsAndShareholders.getInitialProps = getInitialProps

export default InvestorsAndShareholders
